/** Canonical public-map place type for transport stops (API uses transit_stop). */
export const TRANSIT_STOP_PLACE_TYPE = 'transit_stop';

export function isTransitStopPlaceType(placeType?: string | null): boolean {
  return placeType === TRANSIT_STOP_PLACE_TYPE || placeType === 'transport_stop';
}

export function transitStopFieldsFromExtras(extra: Record<string, unknown> | undefined) {
  if (!extra) return {};
  const routes = Array.isArray(extra.routes) ? extra.routes.map(String).filter(Boolean) : undefined;
  const operators = Array.isArray(extra.operators) ? extra.operators.map(String).filter(Boolean) : undefined;
  return {
    stopRef: typeof extra.ref === 'string' && extra.ref.trim() ? extra.ref.trim() : undefined,
    routes: routes?.length ? routes : undefined,
    operators: operators?.length ? operators : undefined,
    shelter: extra.shelter != null ? Boolean(extra.shelter) : undefined,
    bench: extra.bench != null ? Boolean(extra.bench) : undefined,
    lighting: extra.lighting != null ? Boolean(extra.lighting) : undefined,
  };
}

/** Prefill transport stop form state from place card / place details API fields. */
export function transitStopFieldsFromPlace(source: {
  stopRef?: string | null;
  stop_ref?: string | null;
  routes?: string[] | null;
  operators?: string[] | null;
  shelter?: boolean | null;
  bench?: boolean | null;
  lighting?: boolean | null;
}) {
  const stopRef = (source.stopRef ?? source.stop_ref)?.trim() || undefined;
  const routes = Array.isArray(source.routes) ? source.routes.map(String).filter(Boolean) : [];
  const operators = Array.isArray(source.operators) ? source.operators.map(String).filter(Boolean) : [];
  return {
    stopRef,
    routes,
    operators,
    shelter: source.shelter != null ? Boolean(source.shelter) : false,
    bench: source.bench != null ? Boolean(source.bench) : false,
    lighting: source.lighting != null ? Boolean(source.lighting) : false,
  };
}
